import Layout from "../../components/layouts/layout.comp";
import { useTranslation } from "../../core/translation.core";
import AddLink from "../../components/form/addLink.comp";
import PendingDeliveries from "../../components/delivery/pendingDeliveries";

export default function DeliveriesPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.delivery.deliveries)} titleBtn={<AddLink id="vehicle-create" href="/delivery/scheduleCreate" />}>
      <PendingDeliveries />
    </Layout>
  );
}
